import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DetailViewComponent } from '../../detail-view.component';

// text,email,tel,textarea,password,
@Component({
    selector: 'empty-box',
    templateUrl: './empty-box.component.html',
    styleUrls: ['./empty-box.component.scss'],
    standalone: false
})
export class EmptyBoxComponent implements OnInit, OnDestroy {
  @Input() prop: any = {};
  @Input() viewExpanded: boolean;

  constructor(public detailViewComponent: DetailViewComponent) {}

  ngOnInit() {}

  ngOnDestroy() {}
}
